var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17 20.75h-10c-4.41 0-5.75-1.34-5.75-5.75v-.5c0-.41.34-.75.75-.75.96 0 1.75-.79 1.75-1.75s-.79-1.75-1.75-1.75c-.41 0-.75-.34-.75-.75v-.5c0-4.41 1.34-5.75 5.75-5.75h10c4.41 0 5.75 1.34 5.75 5.75v1c0 .41-.34.75-.75.75-.96 0-1.75.79-1.75 1.75s.79 1.75 1.75 1.75c.41 0 .75.34.75.75 0 4.41-1.34 5.75-5.75 5.75zm-14.25-5.59c.02 3.44.73 4.09 4.25 4.09h10c3.34 0 4.15-.59 4.24-3.59-1.43-.34-2.49-1.63-2.49-3.16s1.07-2.82 2.5-3.16v-.34c0-3.57-.67-4.25-4.25-4.25h-10c-3.52 0-4.23.65-4.25 4.09 1.43.34 2.5 1.63 2.5 3.16s-1.07 2.82-2.5 3.16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10 7.25c-.41 0-.75-.34-.75-.75v-2.5c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10 14.5802c-.41 0-.75-.34-.75-.75v-3.67c0-.41004.34-.75004.75-.75004s.75.34.75.75004v3.67c0 .42-.34.75-.75.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m10 20.75c-.41 0-.75-.34-.75-.75v-2.5c0-.41.34-.75.75-.75s.75.34.75.75v2.5c0 .41-.34.75-.75.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.677995c66262f4ad78d09df819181291.svg";
export { ForwardRef as ReactComponent };